import React from 'react';
import { Modal, Button, Message, List } from 'semantic-ui-react';

interface SeparateContractModalProps {
  open: boolean;
  onCancel: () => void;
  onSeparate: () => void;
  onKeepTogether: () => void;
  aditivoCount: number;
  renegociacaoCount: number;
}

export const SeparateContractModal: React.FC<SeparateContractModalProps> = ({
  open,
  onCancel,
  onSeparate,
  onKeepTogether,
  aditivoCount,
  renegociacaoCount
}) => {
  return (
    <Modal open={open} onClose={onCancel} size="small">
      <Modal.Header>📋 Contrato com Linhas Mistas</Modal.Header>
      <Modal.Content>
        <Message info>
          <Message.Header>TIM não aceita contratos mistos</Message.Header>
          <p>
            A TIM não aceita contratos que contenham linhas de Aditivo e Renegociação juntas.
            Recomendamos separar em dois contratos distintos.
          </p>
        </Message>

        <div style={{ marginTop: '1.5rem', marginBottom: '1rem' }}>
          <p><strong>Linhas detectadas:</strong></p>
          <List>
            <List.Item>
              <List.Icon name="plus circle" color="green" />
              <List.Content>
                <strong>{aditivoCount}</strong> {aditivoCount === 1 ? 'linha de' : 'linhas de'} <strong>Aditivo</strong>
              </List.Content>
            </List.Item>
            <List.Item>
              <List.Icon name="refresh" color="blue" />
              <List.Content>
                <strong>{renegociacaoCount}</strong> {renegociacaoCount === 1 ? 'linha de' : 'linhas de'} <strong>Renegociação</strong>
              </List.Content>
            </List.Item>
          </List>
        </div>

        <div style={{ marginTop: '1.5rem', padding: '1rem', background: '#f0f8ff', borderRadius: '4px', border: '1px solid #d0e8ff' }}>
          <p style={{ margin: 0 }}>
            <strong>✨ Recomendação:</strong> Ao separar, dois contratos serão criados automaticamente, 
            um para cada tipo de linha. Ambos ficarão agrupados para facilitar o gerenciamento.
          </p>
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onCancel}>
          Cancelar
        </Button>
        <Button onClick={onKeepTogether} disabled>
          Manter Junto
        </Button>
        <Button primary onClick={onSeparate}>
          Separar Contratos
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

